import gql from "graphql-tag";

export const searchQueryFragment = gql`
	fragment searchQueryFragment on Search {
		response {
			... on SearchResponse {
				location {
					city
					state
					lat
					lng
					zip
				}
				providers {
					estimated_price(answerKeyFilters: $answerKeyFilters) {
						total
						unit
						description
					}
					... on SearchResponseProvider {
						provider {
							_id
							metrics {
								reviews_count
								reviews_avg
								hires
							}
							award {
								top_pro
								high_demand
								online
							}
							company_name
							company_founded
							image(approved: true) {
								hash
								value
							}
							reviews(
								limit: 2
								sort: { created_at: -1 }
								filter: { active: true, _operators: { rating: { gte: 4 } } }
							) {
								rating
								author
								message {
									body
								}
							}
							profile {
								url
							}
							intro
							about {
								question
								answer
								generated
							}
							business_location {
								city
								state
								zip
								lat
								lng
							}
							location {
								city
								state
								zip
							}
							verified {
								badge
							}
						}
					}
				}
				filterQuestions {
					_id
					text
					quickPick
					description
					key
					filter
					price_questions(filter: { active: true, type: price }) {
						_id
					}
					answers(filter: { active: true }, sort: { position: 1 }) {
						_id
						key
						value
						type
					}
				}
				service {
					_id
					name
					name_proper
					credits
					midtail
					phrase
					plural
					singular
					affinities(filter: { show_in_search: true, active: true }) {
						affinity {
							name
							midtail
							key
							name_proper
						}
					}
					key
					url
				}
			}
		}
	}
`;

export const serviceQueryFragment = gql`
	fragment serviceQueryFragment on Service {
		_id
		name
		credits
		midtail
		phrase
		plural
		name_proper
		singular
		affinities(filter: { show_in_search: true, active: true }) {
			affinity {
				name
				midtail
				name_proper
				key
			}
		}
		key
		url
	}
`;

export const serverServiceQueryFragment = gql`
	fragment serviceQueryFragment on Service {
		phrase
	}
`;

export const accountByTokenQueryFragment = gql`
	fragment accountByTokenQueryFragment on Account {
		provider {
			claimed
			track {
				source
			}
		}
	}
`;
